/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { createAction } from '../../../../utils/redux-utils';
import { CashBoxLastDocument } from '../../../api/cashBoxes/cashBoxesClient.typings';
import { Notification } from '../../../../utils/utils';

export enum CashBoxLastDocumentTabActionType {
    EXIT_LAST_DOCUMENT_TAB = 'CashBoxLastDocumentTab/ exit tab',
    FETCH_LAST_DOCUMENT = 'CashBoxLastDocumentTab/ fetch last document data start',
    FETCH_LAST_DOCUMENT_SUCCESS = 'CashBoxLastDocumentTab/ fetch last document data success',
    FETCH_LAST_DOCUMENT_ERROR = 'CashBoxLastDocumentTab/ fetch last document data error',
}

export const exitLastDocumentTabAction = () => createAction(CashBoxLastDocumentTabActionType.EXIT_LAST_DOCUMENT_TAB);

export const fetchLastDocumentAction = () => createAction(CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT);

export const fetchLastDocumentSuccessAction = (payload: CashBoxLastDocument) =>
    createAction(CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT_SUCCESS, payload);

export const fetchLastDocumentErrorAction = (notification: Notification) =>
    createAction(CashBoxLastDocumentTabActionType.FETCH_LAST_DOCUMENT_ERROR, { notification });

export type CashBoxLastDocumentTabAction =
    | ReturnType<typeof exitLastDocumentTabAction>
    | ReturnType<typeof fetchLastDocumentAction>
    | ReturnType<typeof fetchLastDocumentSuccessAction>
    | ReturnType<typeof fetchLastDocumentErrorAction>;
